// React
import React from "react";

// Internal Components
import AutoResizeTextArea from "../../../../components/ui/AutoResizeTextarea/AutosizeTextarea";
import { continuationCalculator } from "../../../../utils/UtilityFunctions";

const TILE_CONFIG = {
  placeholders: {
    name: "John Doer",
    quote: "The mind has no answers. The heart has no questions.",
    ikigai:
      "To empower the experience of life to commensurate with the nature of reality.",
  },
  visionValuesState: [
    {
      inputName: { placeholder: "Effort" },
      inputDescription: {
        values: { placeholder: "Giving my best at every opportunity" },
        vision: { placeholder: "Learn a new language" },
      },
    },
    {
      inputName: { placeholder: "Attitude" },
      inputDescription: {
        values: {
          placeholder:
            "A joyful, mindful perspective in the context of daily courage",
        },
        vision: { placeholder: "Run a half marathon" },
      },
    },
    {
      inputName: { placeholder: "Character" },
      inputDescription: {
        values: { placeholder: "Resolute in adversity, humilitous in acclaim" },
        vision: { placeholder: "Visit 3 new countries" },
      },
    },
    {
      inputName: { placeholder: "Visionary" },
      inputDescription: {
        values: { placeholder: "Make the difference written on your bones" },
        vision: { placeholder: "Read 10 books" },
      },
    },
    {
      inputName: { placeholder: "Love" },
      inputDescription: {
        values: { placeholder: "Unconditionally support other people" },
        vision: { placeholder: "Be present" },
      },
    },
  ],
};

function YearTile({ tile_name, value, children, handleChange, gridArea }) {
  const style = gridArea ? { gridArea } : {};

  return (
    <div
      className={`yeartile ${tile_name}`}
      style={style}
      data-tooltip={tile_name}
    >
      <div className="tutorial-header">
        <div className="iconDiv">
          <div className="newIcon">{children}</div>
          <label className="score_label">
            <strong style={{ textTransform: "capitalize" }}>{tile_name}</strong>
          </label>
        </div>
      </div>

      {/* This new wrapper allows the content to grow and fill the tile's height */}
      <div className="tile-content">
        {(tile_name === "name" ||
          tile_name === "quote" ||
          tile_name === "ikigai") && (
          <AutoResizeTextArea
            className="formInput"
            wrap="soft"
            autoComplete="off"
            placeholder={TILE_CONFIG.placeholders[tile_name]}
            name={tile_name}
            value={value}
            onChange={(e) => handleChange(e, tile_name)}
          />
        )}

        {tile_name === "birthday" && (
          <input
            className="birthdayInput"
            type="date"
            value={value}
            name="birthdate"
            onChange={(e) => handleChange(e, tile_name)}
          />
        )}

        {tile_name === "continuation" && (
          <textarea
            id="cont"
            className="formInput year"
            style={{ resize: "none" }}
            wrap="soft"
            autoComplete="off"
            value={
              value
                ? `Today is unique. It is day number ${value} in my life so far.`
                : `Add your birthday and your continuation will be automatically calculated.`
            }
            placeholder=""
            readOnly
          />
        )}

        {tile_name === "memory" && (
          <AutoResizeTextArea
            id="memory"
            className="formInput year"
            wrap="soft"
            autoComplete="off"
            value={value?.memory ?? ""}
            placeholder="Your memory from the previous year will appear here."
            readOnly
          />
        )}

        {(tile_name === "vision" || tile_name === "values") && (
          <div className="valuesRow">
            {TILE_CONFIG.visionValuesState.map((div, index) => {
              const arr = ["one", "two", "three", "four", "five"];
              const nombre = arr[index];
              return (
                <div key={index} className="valuesDiv">
                  {tile_name === "values" && (
                    <input
                      type="text"
                      wrap="soft"
                      autoComplete="off"
                      placeholder={div.inputName.placeholder}
                      title="title"
                      value={value?.[nombre]?.title ?? ""}
                      name={nombre}
                      onChange={(e) => handleChange(e, tile_name)}
                    />
                  )}
                  <AutoResizeTextArea
                    wrap="soft"
                    autoComplete="off"
                    placeholder={
                      tile_name === "values"
                        ? div.inputDescription.values.placeholder
                        : div.inputDescription.vision.placeholder
                    }
                    title="description"
                    tile_name={tile_name}
                    name={nombre}
                    value={value?.[nombre]?.description ?? ""}
                    handleChange={handleChange}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default YearTile;
